// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__30ejD","success":"AnswerItem_success__3LN_X","error":"AnswerItem_error__38Xjc"};